import React, { useState } from "react";
import Button from "components/Elements/Button/Button.js";
import DisplayEmbedInputs from "../EmbedFormInputs/DisplayEmbedInputs.js";
import EmbedFormTemplateHeader from "./EmbedFormTemplateHeader.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "contexts/contentContext/contentContext.js";

const EmbedFormTemplateBody = ({
  formDetails,
  hideDetails,
  includeTitleAndDesc,
  displayImageForm,
  formImage,
  displayTitleForm,
  formTitle,
  displayDescriptionForm,
  formDescription,
  embedJson,
  direction,
  errorFields,
  setEmbedJson,
  buttonBackgroundColor,
  prevCookies,
  createEmbedMail,
  buttonTextColor,
  loadingButton,
  searchParams,
  isDemoEmbedPage,
  typeUser,
  isPreview,
  embedPageEditMode,
  formInEmbedPage,
  maxFormHeight,
  innerScrollHeight,
  displayFooterLinks,
  isInsideIframe,
  iframeHeight,
}) => {
  const { getTextByKey } = useContent();
  const [disableButton, setDisableButton] = useState(false);
  const headerHeight = hideDetails ? 0 : 115;
  const buttonHeight = 102;
  const footerHeight = displayFooterLinks ? 60 : 0;
  const heightOfFooterAndHeader = headerHeight + buttonHeight + footerHeight;
  maxFormHeight =
    isInsideIframe && maxFormHeight > 0 && iframeHeight !== maxFormHeight
      ? iframeHeight
      : maxFormHeight;
  const maxHeightInputs = maxFormHeight - heightOfFooterAndHeader;

  const handleCreateEmbedMail = async () => {
    if (disableButton) return;
    setDisableButton(true);
    await createEmbedMail();
    setDisableButton(false);
  };

  return (
    <div className="embed-dynamic-body">
      {!hideDetails && (
        <EmbedFormTemplateHeader
          includeTitleAndDesc={includeTitleAndDesc}
          displayImageForm={displayImageForm}
          formImage={formImage}
          displayTitleForm={displayTitleForm}
          formTitle={formTitle}
          displayDescriptionForm={displayDescriptionForm}
          formDescription={formDescription}
          isDemoEmbedPage={isDemoEmbedPage}
        />
      )}
      <div
        className={`embed-dynamic-inputs ${
          formDetails.Embed_Dynamic_Background_Color_Code &&
          formDetails.Embed_Dynamic_Background_Color_Code.includes("eceff1")
            ? "special-inputs-color"
            : ""
        } ${
          !formInEmbedPage
            ? !innerScrollHeight
              ? "embed-dynamic-inputs-full-height"
              : ""
            : ""
        }`}
        style={{
          maxHeight: !formInEmbedPage && innerScrollHeight && maxHeightInputs,
          minHeight:
            !formInEmbedPage &&
            innerScrollHeight &&
            maxHeightInputs < 330 &&
            "unset",
        }}
      >
        {embedJson &&
          embedJson.map((item, i) => (
            <div key={i} className="embed-dynamic-form-input">
              <DisplayEmbedInputs
                isDemoEmbedPage={isDemoEmbedPage}
                direction={direction}
                urlParameter={
                  typeUser === "premium"
                    ? searchParams["field" + i] !== undefined
                      ? searchParams["field" + i]
                      : null
                    : null
                }
                isErrorField={
                  errorFields.filter(
                    (element) => element.item.Lead_Dynamic_Field_Order === i
                  ).length > 0
                    ? true
                    : false
                }
                errorFields={errorFields}
                embedJson={embedJson}
                setEmbedJson={setEmbedJson}
                field={item}
                fieldKey={i}
                buttonsColor={buttonBackgroundColor}
                prevCookie={
                  prevCookies ? (prevCookies[i] ? prevCookies[i] : null) : null
                }
              />
            </div>
          ))}
      </div>
      {formDetails && (
        <div className={`continue-button`} onClick={handleCreateEmbedMail}>
          {isPreview || embedPageEditMode ? (
            <Tooltip
              id={"form-continue-tooltip"}
              tooltipTextKey="form-continue-tooltip"
              //hardPositioned
              top
            >
              <Button
                tabIndex={0}
                style={{
                  backgroundColor: buttonBackgroundColor,
                  color: buttonTextColor,
                }}
                disabled={disableButton}
              >
                {loadingButton ? (
                  <Image alt="" title="" name="preloader" ext="gif" />
                ) : (
                  getTextByKey("form-continue")
                )}
              </Button>
            </Tooltip>
          ) : (
            <Button
              tabIndex={0}
              style={{
                backgroundColor: buttonBackgroundColor,
                color: buttonTextColor,
              }}
              disabled={disableButton}
            >
              {loadingButton ? (
                <Image alt="" title="" name="preloader" ext="gif" />
              ) : (
                getTextByKey("form-continue")
              )}
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default EmbedFormTemplateBody;
